export default __webpack_public_path__ + "static/winter12-93d51b4227d983133356b8d9d39f63c7.webp";